import { SolarContract } from "@edp-models/edp-solar-contract.model";
import { Action } from "@ngrx/store";

export enum ESolarActions {
    GetSolarContract = "[Solar] Get Solar Contract",
    SetSolarContract = "[Solar] Set Solar Contract",
}

export class GetSolarContract implements Action {
    public readonly type = ESolarActions.GetSolarContract;
    constructor(public accountNumber: string) {}
}

export class SetSolarContract implements Action {
    public readonly type = ESolarActions.SetSolarContract;
    constructor(public payload: SolarContract[], public accountNumber: string) {}
}

export type SolarActions = GetSolarContract | SetSolarContract;
